module.exports = __webpack_public_path__ + "static/images/warning-triangle.2o8wKU3.svg";